import CityPageTemplate from "../city-template/CityPageTemplate";
import { lasVegasConfig } from "./data";

export default function LasVegasPage() {
  return <CityPageTemplate config={lasVegasConfig} />;
}